import React from 'react';
import { useTranslation } from 'react-i18next';
import {
    FormControl,
    Select,
    MenuItem,
    Box,
    Typography,
} from '@mui/material';
import {
    Language as LanguageIcon,
} from '@mui/icons-material';

const LanguageSwitcher = () => {
    const { i18n } = useTranslation();

    const handleLanguageChange = (event) => {
        const selectedLanguage = event.target.value;
        console.log('Changing language to:', selectedLanguage);
        i18n.changeLanguage(selectedLanguage);
        console.log('Language changed, current language:', i18n.language);
    };

    const getLanguageLabel = (code) => {
        const languages = {
            en: 'English',
            es: 'Español'
        };
        return languages[code] || code;
    };

    return (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <LanguageIcon fontSize="small" />
            <FormControl size="small" sx={{ minWidth: 120 }}>
                <Select
                    value={i18n.language}
                    onChange={handleLanguageChange}
                    displayEmpty
                    MenuProps={{ disableScrollLock: true }}
                    sx={{
                        color: 'inherit',
                        '& .MuiOutlinedInput-notchedOutline': {
                            borderColor: 'rgba(255, 255, 255, 0.23)',
                        },
                        '&:hover .MuiOutlinedInput-notchedOutline': {
                            borderColor: 'rgba(255, 255, 255, 0.5)',
                        },
                        '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                            borderColor: 'white',
                        },
                        '& .MuiSvgIcon-root': {
                            color: 'inherit',
                        },
                    }}
                >
                    <MenuItem value="en">
                        <Typography variant="body2">
                            {getLanguageLabel('en')}
                        </Typography>
                    </MenuItem>
                    <MenuItem value="es">
                        <Typography variant="body2">
                            {getLanguageLabel('es')}
                        </Typography>
                    </MenuItem>
                </Select>
            </FormControl>
        </Box>
    );
};

export default LanguageSwitcher;
